"use strict";

var _classCallCheck = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('preact'),
    h = _require.h,
    Component = _require.Component,
    createRef = _require.createRef;

var TRANSITION_MS = 300;

module.exports = /*#__PURE__*/function (_Component) {
  _inherits(FadeIn, _Component);

  var _super = _createSuper(FadeIn);

  function FadeIn() {
    var _this;

    _classCallCheck(this, FadeIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.ref = createRef();
    return _this;
  }

  _createClass(FadeIn, [{
    key: "componentWillEnter",
    value: function componentWillEnter(callback) {
      this.ref.current.style.opacity = '1';
      this.ref.current.style.transform = 'none';
      setTimeout(callback, TRANSITION_MS);
    }
  }, {
    key: "componentWillLeave",
    value: function componentWillLeave(callback) {
      this.ref.current.style.opacity = '0';
      this.ref.current.style.transform = 'translateY(350%)';
      setTimeout(callback, TRANSITION_MS);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return h("div", {
        className: "uppy-Informer-animated",
        ref: this.ref
      }, children);
    }
  }]);

  return FadeIn;
}(Component);